import { Tag } from 'src/types/helios/Tags';
import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

export const AuditTemplateValidationPaths = {
  NAME: {
    path: 'name',
    message: 'Error: Please enter the template name.',
  },
  DISCRIPTION: {
    path: 'description',
    message: 'Error: Please enter the description.',
  },
  DIVISION: {
    path: 'division',
    message: 'Error: Please select the divison.',
  },
  BUSINESS_UNIT: {
    path: 'businessUnit',
    message: 'Error: Please select the business unit.',
  },
  LOCATIONS_INCLUDED: {
    path: 'locationsIncluded',
    message: 'Error: Please select the location.',
  },
  TAGS: {
    path: 'tags',
    message: 'Error: Please select the tags.',
  },

  TAGS_MANDATORY_VALIDATION: {
    path: 'tags',
    message: 'Error: Please include all mandatory tags.',
  },

  TAGS_MAX_VALIDATION: {
    path: 'tags',
    message: 'Error: Max tag values reached for this template.',
  },
  AUDIT_EXPIRATION_SETTINGS: {
    path: 'auditExpirationSettings',
    message: 'Error: Please set at least 1 day or 1 month for audit expiration.',
  },
} as const;

export const AuditTemplateValidator = (tagsList: readonly Tag[] = []): FormValidator => {
  const validator = new FormValidator();

  validator.addRule(
    AuditTemplateValidationPaths.NAME.path,
    ValidationRules.required,
    AuditTemplateValidationPaths.NAME.message,
  );
  // Description is now optional - no validation needed
  validator.addRule(
    AuditTemplateValidationPaths.DIVISION.path,
    ValidationRules.required,
    AuditTemplateValidationPaths.DIVISION.message,
  );
  validator.addRule(
    AuditTemplateValidationPaths.BUSINESS_UNIT.path,
    ValidationRules.required,
    AuditTemplateValidationPaths.BUSINESS_UNIT.message,
  );
  validator.addRule(
    AuditTemplateValidationPaths.LOCATIONS_INCLUDED.path,
    ValidationRules.required,
    AuditTemplateValidationPaths.LOCATIONS_INCLUDED.message,
  );
  validator.addRule(
    AuditTemplateValidationPaths.TAGS.path,
    ValidationRules.required,
    AuditTemplateValidationPaths.TAGS.message,
  );
  validator.addRule(
    AuditTemplateValidationPaths.TAGS.path,
    ValidationRules.custom((value: any, _?: Record<string, unknown>) => {
      return value && Object.entries(value).length > 0;
    }),
    AuditTemplateValidationPaths.TAGS.message,
  );

  validator.addRule(
    AuditTemplateValidationPaths.TAGS_MANDATORY_VALIDATION.path,
    (value) => {
      // Check if all mandatory tags are included
      const mandatoryTagGroupNames = tagsList
        .filter((tag) => tag.isMandatoryForAuditTemplates === true && tag.tagGroupName)
        .map((tag) => tag.tagGroupName!);

      const selectedTagGroupNames = Object.keys(value || {});
      return mandatoryTagGroupNames.every((tagGroupName) =>
        selectedTagGroupNames.includes(tagGroupName),
      );
    },
    AuditTemplateValidationPaths.TAGS_MANDATORY_VALIDATION.message,
  );

  validator.addRule(
    AuditTemplateValidationPaths.TAGS_MAX_VALIDATION.path,
    (value) => {
      const maxLimitTags = tagsList?.filter(
        (tag) =>
          tag.maxTagsPerTemplate &&
          tag.tagGroupName &&
          value[tag.tagGroupName] &&
          value[tag.tagGroupName].length > tag.maxTagsPerTemplate,
      );
      return maxLimitTags?.length === 0;
    },
    AuditTemplateValidationPaths.TAGS_MAX_VALIDATION.message,
  );

  validator.addRule(
    AuditTemplateValidationPaths.AUDIT_EXPIRATION_SETTINGS.path,
    ValidationRules.custom((value: any, _?: Record<string, unknown>) => {
      if (
        !value ||
        ((!value.days || value.days < 1) && (!value.months || value.months < 1))
      ) {
        return false;
      }
      return true;
    }),
    AuditTemplateValidationPaths.AUDIT_EXPIRATION_SETTINGS.message,
  );

  return validator;
};
